import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DeleteProductCartPage } from './delete-product-cart.page';
import { ModuleSharedModule } from "../../modules/module-shared.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModuleSharedModule,
  ],
  declarations: [DeleteProductCartPage],
  exports: [DeleteProductCartPage],
})
export class DeleteProductCartPageModule {}
